// 新たにキャンペーンが行われる場合、以下を必ず変更・再ビルドを行うこと
// appName -> YYYYMMcampaign_name 等
// minApplyPrice -> レシートの最低合計金額
// url -> シナジーの本番URL
// tooltip -> シナジーの本番URL＋ツールチップの画像ファイル名
// shoplist -> 凸版より提供される最新の店舗リスト

export default {
    // フォーム名
    appName: "2018_dream",
    // レシート入力可能最大数
    maxReceipt: 10,
    // 応募可能最小金額
    minApplyPrice: 1000,
    // 合計金額欄の表記 (現計または小計)
    priceLabel: "小計",
    // 開始日時
    minDate: new Date(2018, 11 - 1, 24),
    // 終了日時
    maxDate: new Date(2018, 12 - 1, 12),
    // HTMLテンプレート
    templates: {
        tooltip: `<div id="tooltip">
  <img src="https://lsgb.f.msgs.jp/fcnts/lsgb/tooltip.png" alt="">
</div>`,
        tooltip2: `<div id="tooltip">
  <img src="https://lsgb.f.msgs.jp/fcnts/lsgb/img_receipt2.jpg" alt="">
</div>`,
        tooltip3: `<div id="tooltip">
  <img src="https://lsgb.f.msgs.jp/fcnts/lsgb/img_receipt3.jpg" alt="">
</div>`,
        tooltip4: `<div id="tooltip">
  <img src="https://lsgb.f.msgs.jp/fcnts/lsgb/img_receipt4.jpg" alt="">
</div>`,
        tooltip5: `<div id="tooltip">
  <img src="https://lsgb.f.msgs.jp/fcnts/lsgb/img_receipt5.jpg" alt="">
</div>`
    },

    // 各種セレクタ
    selector: {
        receiptBlock: ".receipt-block",
        receipt: ".receiptInput",
        receiptAppend: ".receipt-append",
        receiptRemove: ".receipt-remove",
        date: ".date",
        shopList: ".shoplist",
        hiddenStoreName: ".store-name",
        hiddenStoreId: ".store-id",
        price: ".price",
        totalPrice: "#total",
        prizeBlock: "#prize-block",
        userBlock: ".user",
        inquiryBlock: ".inquiry"
    },
    // 店舗一覧
    shopList: {
        "0187": "明石硯町店",
        "0161": "旭高殿店",
        "0013": "尼崎食満店",
        "0142": "尼崎難波店",
        "0031": "天美店",
        "0092": "天美我堂店",
        "0041": "伊川谷店",
        "0194": "生駒店",
        "0015": "石切店",
        "0103": "泉大津条南店",
        "0057": "泉佐野貝田店",
        "0129": "和泉中央店",
        "0136": "和泉府中店",
        "0168": "和泉万町店",
        "0148": "伊丹荒牧店",
        "0058": "伊丹野間店",
        "0175": "茨木真砂店",
        "0164": "今川店",
        "0196": "上野芝店",
        "0133": "魚崎店",
        "0125": "宇治樋ノ尻店",
        "0104": "宇治槙島店",
        "0109": "梅の里店",
        "0195": "大蓮北店",
        "0089": "大和田店",
        "0151": "尾崎店",
        "0093": "貝塚店",
        "0063": "学園前店",
        "0162": "楽音寺店",
        "0166": "香芝二上店",
        "0154": "柏原大県店",
        "0048": "柏原本郷店",
        "0061": "春日野道店",
        "0141": "樫原店",
        "0146": "金岡店",
        "0159": "河南町店",
        "0060": "加納店",
        "0149": "加美店",
        "0038": "萱島店",
        "0045": "苅田店",
        "0079": "河合町店",
        "0167": "川西加茂店",
        "0035": "河原城店",
        "0066": "岸和田磯上店",
        "0017": "北須磨店",
        "0091": "北野田店",
        "0172": "久宝寺駅前店",
        "0071": "喜連西店",
        "0157": "熊取店",
        "0132": "倉治店",
        "0044": "郡津店",
        "0014": "神戸北町店",
        "0085": "神戸星和台店",
        "0174": "香里ヶ丘店",
        "0027": "香里西店",
        "0019": "小阪店",
        "0184": "五条西小路店",
        "0140": "堺草部店",
        "0198": "堺高須店",
        "0080": "堺土師店",
        "0117": "逆瀬川店",
        "0173": "嵯峨広沢店",
        "0197": "三田店",
        "0036": "志紀店",
        "0052": "七道店",
        "0049": "渋川店",
        "0155": "下新庄店",
        "0102": "尺土店",
        "0028": "新石切店",
        "0072": "新庄花内店",
        "0032": "新森店",
        "0185": "住吉沢之町店",
        "0076": "諏訪の森店",
        "0189": "西神中央店",
        "0169": "善根寺店",
        "0128": "泉北深阪店",
        "0120": "太子橋店",
        "0192": "大東赤井店",
        "0030": "高槻大塚店",
        "0158": "高槻春日店",
        "0165": "高槻富田丘店",
        "0179": "高槻緑町店",
        "0119": "鷹殿店",
        "0190": "宝塚東洋町店",
        "0090": "宝塚中筋店",
        "0033": "田島店",
        "0153": "多田店",
        "0143": "巽北店",
        "0163": "巽西店",
        "0183": "垂水多聞店",
        "0108": "田原本店",
        "0186": "丹波橋店",
        "0188": "塚口店",
        "0084": "塚本店",
        "0122": "鶴見店",
        "0150": "鶴見今津店",
        "0126": "天理北店",
        "0110": "道明寺店",
        "0037": "豊中豊南店",
        "0124": "豊中本町店",
        "0181": "長岡京店",
        "0191": "長岡天神店",
        "0123": "長尾西店",
        "0170": "中小阪店",
        "0115": "長吉店",
        "0094": "菜畑店",
        "0086": "名張店",
        "0012": "仁川店",
        "0130": "西宮熊野店",
        "0171": "西宮前浜店",
        "0054": "西宮門戸店",
        "0053": "西宮山口店",
        "0193": "ニッケパークタウン加古川店",
        "0023": "寝屋川店",
        "0178": "寝屋川宇谷店",
        "0100": "寝屋川西店",
        "0180": "羽束師店",
        "0021": "花園店",
        "0134": "羽曳野島泉店",
        "0147": "阪神ショッピングセンター店",
        "0025": "東岸和田店",
        "0024": "瓢箪山店",
        "0039": "枚方店",
        "0107": "枚方高野道店",
        "0156": "平野流町店",
        "0088": "福島吉野店",
        "0144": "藤井寺店",
        "0011": "布施店",
        "0074": "舟田店",
        "0070": "古川橋店",
        "0105": "坊城店",
        "0081": "法隆寺店",
        "0083": "松原店",
        "0152": "御池台店",
        "0067": "御厨店",
        "0043": "水無瀬店",
        "0056": "南木の本店",
        "0131": "南住吉店",
        "0034": "南津の辺店",
        "0075": "南花屋敷店",
        "0077": "美原店",
        "0138": "都島店",
        "0113": "桃谷駅前店",
        "0176": "森河内店",
        "0047": "諸福店",
        "0050": "八尾店",
        "0099": "八雲店",
        "0160": "矢田店",
        "0018": "山本店",
        "0182": "淀川新高店",
        "0177": "六万寺店"
    }
};
